<div class="policies ">
  <span class="document-title">{{'guestConsentPolicy' | translate}}</span>
  <div class="default-form-field">
    @if (customPolicyText) {
      <p>{{customPolicyText}}</p>
    }
    @if (!customPolicyText) {
      <p>{{'serverBetter' | translate}}</p>
    }

    @if (dataRetentionPolicy.nameRetentionPeriod && dataRetentionPolicy.nameRetentionPeriod!=0) {
      <p>
        {{'weWillKeep' | translate}} <strong>{{'name' | translate}} </strong> {{'maxDays' | translate}} <strong>
      {{dataRetentionPolicy.nameRetentionPeriod}}</strong> {{'days' | translate}}
    </p>
  }
  @if (dataRetentionPolicy.emailRetentionPeriod && dataRetentionPolicy.emailRetentionPeriod!=0) {
    <p>
      {{'weWillKeep' | translate}} <strong class="capitalize">{{'emailAddress' | translate}} </strong> {{'maxDays' | translate}}
      <strong>{{dataRetentionPolicy.emailRetentionPeriod}}</strong> {{'days' | translate}}
    </p>
  }
  @if (dataRetentionPolicy.phoneRetentionPeriod && dataRetentionPolicy.phoneRetentionPeriod!=0) {
    <p>
      {{'weWillKeep' | translate}} <strong>{{'phoneNumber' | translate}} </strong> {{'maxDays' | translate}}
      <strong>{{dataRetentionPolicy.phoneRetentionPeriod}} </strong> {{'days' | translate}}
    </p>
  }
  @if ( dataRetentionPolicy.addressRetentionPeriod && dataRetentionPolicy.addressRetentionPeriod!=0) {
    <p>
      {{'weWillKeep' | translate}} <strong>{{'address' | translate}} </strong> {{'maxDays' | translate}}
      <strong>{{dataRetentionPolicy.addressRetentionPeriod}} </strong> {{'days' | translate}}
    </p>
  }
  @if (dataRetentionPolicy.guestImageRetentionPeriod && dataRetentionPolicy.guestImageRetentionPeriod!=0) {
    <p>
      {{'weWillKeep' | translate}} <strong>{{'guestImage' | translate}} </strong> {{'maxDays' | translate}}
      <strong>{{dataRetentionPolicy.guestImageRetentionPeriod}} </strong> {{'days' | translate}}
    </p>
  }
  @if (dataRetentionPolicy.birthdayAndAnniversaryRetentionPeriod && dataRetentionPolicy.birthdayAndAnniversaryRetentionPeriod!=0) {
    <p
      >
      {{'weWillKeep' | translate}} <strong>{{'birthday&Anniversary' | translate}} </strong> {{'maxDays' | translate}}
      <strong>{{dataRetentionPolicy.birthdayAndAnniversaryRetentionPeriod}} </strong> {{'days' | translate}}
    </p>
  }
  @if (dataRetentionPolicy.customFieldRetentionPeriod && dataRetentionPolicy.customFieldRetentionPeriod!=0) {
    <p>
      {{'weWillKeep' | translate}} <strong>{{'customDetails' | translate}}</strong> {{'maxDays' | translate}}
      <strong>{{dataRetentionPolicy.customFieldRetentionPeriod}} </strong> {{'days' | translate}}
    </p>
  }
</div>
</div>